module.exports = __webpack_public_path__ + "img/picture2.2c1879ed.jpg";